import { render } from "./createone.vue?vue&type=template&id=e89d8354"
import script from "./createone.vue?vue&type=script&lang=js"
export * from "./createone.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__